import React, {Component} from 'react';
import { Col, Label, Input, FormGroup } from "reactstrap";
import _ from 'lodash';

export default class FormInput extends Component {
    constructor(props) {
        super(props);

        this.state = {
            alerta: this.props.alerta
        };
    }

    componentDidUpdate(prevProps) {
        if(prevProps.alerta !== this.props.alerta) {
            this.setState({
                alerta: this.props.alerta
            });
        }
    };

    handleChange = (event) => {
        if (this.props.sanitizar) {
            event.target.value = this.props.sanitizar(event.target.value);
        }
        if (this.props.onChange) {
            this.props.onChange(event);
        }
    }

    handleBlur = (event) => {
        if (this.props.sanitizar) {
            event.target.value = this.props.sanitizar(event.target.value);
        }
        var invalido = (this.props.validador) ? this.props.validador(event.target.value) : false;
        if (!invalido) {
            this.salva(event);
            this.props.validacaoStore && this.props.validacaoStore(true)
        } 
        if(invalido && this.props.validacaoStore){
            this.props.validacaoStore(false)
        }
        this.setState({
            alerta: invalido
        });
    }
    
    salva = (event) => {
        this.props.onChange(event, event)
        if (this.props.onBlur) {
            this.props.onBlur(_.get(this.props.objeto, this.props.dado));
        }
    }

    render() {
        return(
            <Col className={`${this.props.className ? this.props.className : ""} ${this.props.col ? this.props.col : ""}`}
                xs={this.props.xs ? this.props.xs : 'auto'}
                sm={this.props.sm ? this.props.sm : 'auto'}
                md={!this.props.col && this.props.md ? this.props.md : 'auto'}>
                <FormGroup>
                    { this.props.titulo && <Label>{ this.props.titulo } { this.props.obrigatorio ? <span className="label-danger">*</span> : "" } </Label> }
                    <Input defaultValue= { this.props.value ? this.props.value : _.get(this.props.objeto, this.props.dado) }
                        className={this.props.uppercase ? `${this.props.classNames} uppercase` : `${this.props.classNames} `} 
                        disabled = {this.props.bloqueado ? "disabled" : ""}
                        type={ this.props.type ? this.props.type : "text" }
                        min={ this.props.min ? this.props.min : 0 } max={ this.props.max ? this.props.max : 999999 }
                        onChange={ this.handleChange }
                        maxLength={this.props.limiteMaximo ? this.props.limiteMaximo : ""}
                        minLength={this.props.limiteMinimo ? this.props.limiteMinimo : ""}
                        onBlur={ (event) => this.handleBlur(event, event) } 
                        placeholder={ this.props.placeholder ? this.props.placeholder : "" }
                        autoFocus={this.props.autoFocus}/>
                </FormGroup>
                { (this.props.labelStatus && this.props.labelStatus.length>0) ? <Label className="label-danger">{ this.props.labelStatus }</Label> : "" }
                { this.state.alerta
                    && <Col xs={12} className="col-label label-obrigatorio px-0">
                        <Label>{ this.state.alerta }</Label>
                    </Col>
                }
            </Col>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/comum/components/FormInput.js